<template>
    <div class="layout-header">
        <div class="bg"></div>
        <div class="layout-header-l">
            <img class="menu" @click="menuShow = true" src="../assets/img/layout/menu.png" alt="" />
            <img class="logo" src="../assets/img/layout/logo.png" alt="" />
        </div>
        <div class="layout-header-r">
            <Popover v-model="langShow" :offset="[-30, 10]">

                <div class="lang-popup">
                    <div :class="{ active: $i18n.locale === 'zh-CN' }" @click="handleLang('zh-CN')">
                        <span>{{ $t('layout.zh') }}</span>

                    </div>
                    <div :class="{ active: $i18n.locale === 'tc' }" @click="handleLang('tc')">
                        <span>{{ $t('layout.tc') }}</span>
                    </div>
                    <div :class="{ active: $i18n.locale === 'en-US' }" @click="handleLang('en-US')">
                        <span>{{ $t('layout.en') }}</span>
                    </div>

                    <div :class="{ active: $i18n.locale === 'kr' }" @click="handleLang('kr')">
                        <span>{{ $t('layout.kr') }}</span>
                    </div>

                    <div :class="{ active: $i18n.locale === 'jp' }" @click="handleLang('jp')">
                        <span>{{ $t('layout.jp') }}</span>
                    </div>
                </div>
                <template #reference>
                    <img @click="langShow = true" class="langs" src="../assets/img/layout/langs.png" alt="" />
                </template>
            </Popover>
            <!-- <img class="user" v-if="isLogin" src="../assets/img/layout/user.png" alt="" /> -->
            <div class="btn">
                {{userName}}
            </div>
        </div>

        <Popup v-model="menuShow" class="menuPopup" get-container="#app" position="left">
            <div class="menu-header">
                <div class="close">
                    <img @click="menuShow = false" src="../assets/img/layout/close.png" alt="">

                </div>
                <div class="logo">
                    <img src="../assets/img/layout/menu-logo.png" alt="">
                </div>
                <!-- <img @click="menuShow = false" src="../assets/img/close.png" alt=""> -->
            </div>

            <div class="menu-list">
                <div class="menu-list-item" :class="{ active: menuItem?.path === item.path }" @click="handleMenu(item)"
                    v-for="(item, index) in menu" :key="index">
                    <i></i>
                    <div> {{ item.title }}</div>
                </div>
            </div>
        </Popup>
    </div>
</template>
<script>
import { ActionSheet, Popover, Icon, Popup, Field } from 'vant';
import { setLanguage } from "@/utils/cookies";
import { Locale } from 'vant';
import { copyToClipboard } from "@/utils";


import axios from 'axios'
import contractaa from '../views/contract/index.js'

export default {
    name: 'layout-header',
    components: {
        ActionSheet,
        Icon,
        Popup,
        Field,
        Popover
    },
    data() {
        return {
            isLogin: false,
            show: false,
            show1: false,
            check: false,
            menuShow: false,
            langShow: false,
            linkShow: false,
            referenceShow: false,
            walletIcon: '',
            userName: '**...***',
            actions: [

            ],
            checkItem: ''
        };
    },
    computed: {
        menuItem() {
            return this.menu.find((menuItem) => this.$route.name === menuItem.path);
        },
        menu() {
            return [
                {
                    title: this.$t('menu.home'),
                    path: 'home'
                },
                {
                    title: this.$t('menu.mining'),
                    path: 'mining'
                },
                {
                    title: this.$t('menu.wallet'),
                    path: 'wallet'
                },
                {
                    title: this.$t('menu.me'),
                    path: 'me'
                },
            ]
        }
    },
    watch: {
        '$route.path'(path) {
            this.menuShow = false;

        }

    },
    methods: {
        toggleSound() {
            this.$store.commit('toggleSound')
        },
        handleLink() {
            if (this.isLogin) {
                this.linkShow = !this.linkShow
            } else {
                this.linkShow = false
            }
        },
        handleMenu(item) {
            this.menuShow = false;
            if (item.path) {
                this.$router.push({
                    name: item.path
                });
            }
            if (item.lang) {
                this.$i18n.locale = item.lang;
                setLanguage(item.lang)
                Locale.use(item.lang, this.$i18n.messages[item.lang])

            }

        },
        handleLang(lang) {
            this.$i18n.locale = lang;
            setLanguage(lang)
            Locale.use(lang, this.$i18n.messages[lang])
            this.langShow = false

        },
        copy(text) {
            copyToClipboard(text)
        },
        userLogin(){
            let that = this;
            let _token = this.$route.query.token;
            this.$store.state.loginToken = _token;
            _token = encodeURIComponent(_token)
            //console.log(_token);
            axios.post(contractaa.APIURL+'?cmd=getinfobytoken','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    //console.log("axios:"+response.data.Data)
                    that.userName = response.data.Data.memberno
                }
            })
        },
    },
    mounted(){

        this.userLogin();  
        
        console.log("header")
    }
}
</script>
<style lang="less">
.layout-header {
    display: flex;
    justify-content: space-between;
    // position: fixed;
    align-items: center;
    width: 375px;
    height: 50px;
    padding: 0 20px;
    top: 0;
    z-index: 22;
    position: relative;

    >.bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(59, 59, 59);
        -webkit-backdrop-filter: blur(17px);
        backdrop-filter: blur(17px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.16);
        opacity: 0.16;

    }

    &-l {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .logo {
            width: 120px;
            height: 22px;
        }

        .menu {
            width: 20px;
            height: 16px;
            margin-right: 15px;
        }
    }

    &-r {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .langs {
            width: 26px;
            height: 26px;

        }

        .user {
            margin-left: 10px;
            width: 26px;
            height: 26px;
        }

        .btn {
            margin-left: 10px;
            min-width: 56px;
            height: 26px;
            color: #959597;
            font-size: 11px;
            line-height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url('../assets/img/layout/bg.png') no-repeat;
            background-size: 100% 100%;
        }



    }

}

.menuPopup {
    width: 270px;
    height: 100%;
    background: url('../assets/img/layout/menu-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 14px 15px;

    .menu-header {
        margin-bottom: 30px;

        .close {
            margin-bottom: 19px;

            img {
                width: 18px;
                height: 18px;
            }
        }

        .logo {
            width: 141.82px;
            height: 26px;
        }

    }

    .menu-list {
        &-item {
            display: flex;
            align-items: center;

            i {
                margin-bottom: -4px;
                display: block;
                margin-right: 6px;
                height: 3px;
                width: 3px;
                background: #B7B7B7;
                border-radius: 50%;
            }

            margin-bottom: 25px;
            color: #B7B7B7;
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;

            &.active {
                color: #FFFFFF;

                i {
                    background: #fff;

                }
            }
        }
    }
}

.van-popover__content {
    background-color: #232326 !important;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid #2D2D2E !important;
}

.van-popover__arrow {
    border-bottom-color: #2D2D2E !important;
    left: calc(50% + 30px) !important;
}

.lang-popup {
    padding-top: 12px;
    padding-bottom: 2px;
    color: #FFFFFF;
    font-size: 12px;
    line-height: 17px;
    width: 148px;

    >div {
        height: 34px;
        padding: 8px 15px;

        &.active {
            background: rgba(216, 216, 216, 0.09);
            position: relative;

            &::before {
                display: block;
                position: absolute;
                content: ' ';
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                width: 11px;
                height: 11px;
                background: url('../assets/img/layout/check.png') no-repeat;
                background-size: 11px 11px;
            }
        }
    }
}
</style>